import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAssetScopedRecordWorkspacePath } from "@/features/tickets/lib/get-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/records/$recordId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getAssetScopedRecordWorkspacePath({
				orgId: params.orgId,
				ticketId: params.ticketId,
				assetId: params.assetId,
				recordId: params.recordId,
				tab: "form",
			}),
		});
	},
});
